import { DefaultModelProperty, LabelValue } from './standard'
import {
  AlphaOnlyWithSpacesAttribute,
  BeforeNowAttribute,
  EmailAttribute,
  IsNotEmpty,
  IsNotNullAttribute,
  IsValidStateOrProvince,
  MaxAttribute,
  MaxLengthAttribute,
  MinAttribute,
  MinLengthAttribute,
  NumericAttribute,
  OneOfAttribute,
  PastDateAttribute,
  PhoneNumberAttribute,
  SSNAttribute,
  VINAttribute,
  ValidationResult,
  ZipAttribute,
} from './validation'
export interface ValidationRule {
  rule: string
  parameters: string[]
}
export function ProcessValidation<M, P extends keyof M>(
  form: M,
  property: DefaultModelProperty<P>,
  utilValidations: {
    [str: string]: ValidationRule[]
  },
) {
  let name = property.name

  let value: any = form ? form[name] : null

  if (
    value &&
    typeof value === 'object' &&
    value.label !== undefined &&
    value.value !== undefined
  ) {
    value = value.value
  }
  if (utilValidations && utilValidations[name.toString()]) {
    let validationRules = utilValidations[name.toString()]
    let result: ValidationResult = { errors: [], success: [] }
    validationRules.forEach((validationRule: ValidationRule) => {
      let now = new Date()
      switch (validationRule.rule) {
        case 'alphaonlywithspaces':
          AlphaOnlyWithSpacesAttribute().results(result).isOk(value)
          break
        case 'afternow':
          now.setHours(0, 0, 0, 0)
          if (value && value.seconds) {
            value = new Date(value.seconds * 1000)
          }
          PastDateAttribute(now).results(result).isOk(value)
          break
        case 'minlengthequal':
          MinLengthAttribute(
            parseInt(validationRule.parameters[0] || '0', 10),
            true,
          )
            .results(result)
            .isOk(value)
          break
        case 'maxlengthequal':
          MaxLengthAttribute(
            parseInt(validationRule.parameters[0] || '0', 10),
            true,
          )
            .results(result)
            .isOk(value)
          break
        case 'maxvalueequal':
          MaxAttribute(parseInt(validationRule.parameters[0] || '10', 10), true)
            .results(result)
            .isOk(value)
          break
        case 'maxvalue':
          MaxAttribute(parseInt(validationRule.parameters[0] || '10', 10))
            .results(result)
            .isOk(value)
          break
        case 'maxlengthequalorempty':
          if (value && value.trim && value.trim()) {
            MaxLengthAttribute(
              parseInt(validationRule.parameters[0] || '10', 10),
              true,
            )
              .results(result)
              .isOk(value)
          }
          break
        case 'minlengthequalorempty':
          if (value && value.trim && value.trim()) {
            MinLengthAttribute(
              parseInt(validationRule.parameters[0] || '10', 10),
              true,
            )
              .results(result)
              .isOk(value)
          }
          break
        case 'notempty':
          IsNotEmpty().results(result).isOk(value)
          break
        case 'carmake':
        case 'carmodel':
        case 'caryear':
          break
        case 'phone':
          PhoneNumberAttribute().results(result).isOk(value)
          break
        case 'minvalueequal':
          MinAttribute(parseInt(validationRule.parameters[0] || '10', 10), true)
            .results(result)
            .isOk(value)
          break
        case 'minvalue':
          MinAttribute(parseInt(validationRule.parameters[0] || '10', 10))
            .results(result)
            .isOk(value)
          break
        case 'state':
          IsValidStateOrProvince().results(result).isOk(value)
          break
        case 'zip':
          ZipAttribute().results(result).isOk(value)
          break
        case 'number':
          NumericAttribute().results(result).isOk(value)
          break
        case 'VIN':
        case 'vin':
          VINAttribute().results(result).isOk(value)
          break
        case 'email':
          EmailAttribute().results(result).isOk(value)
          break
        case 'birthdate':
        case 'beforenow':
          if (value && value.seconds) {
            value = new Date(value.seconds * 1000)
          }
          BeforeNowAttribute().results(result).isOk(value)
          break
        case 'socialsecurity':
          SSNAttribute().results(result).isOk(value)
          break
        case 'addressline1':
          IsNotNullAttribute().results(result).isOk(value)
          IsNotEmpty().results(result).isOk(value)
          MinLengthAttribute(3, true).results(result).isOk(value)
          MaxLengthAttribute(40, true).results(result).isOk(value)
          break
        case 'addressline2':
          MaxLengthAttribute(40, true).results(result).isOk(value)
          break
        case 'oneof':
          let category = validationRule.parameters[0]
          if (category) {
            let terms: LabelValue<string>[] | null = null
            switch (category) {
              default:
                break
            }
            if (terms) {
              OneOfAttribute((terms as any)?.map((v: any) => v.value))
                .results(result)
                .isOk(value)
            }
          } else {
            console.warn('missing category')
          }
          break
        default:
          break
      }
    })
    return result
  }
  return { errors: [], success: [] }
}
